import { render, staticRenderFns } from "./giveEdit.vue?vue&type=template&id=178ecbe1&scoped=true&"
import script from "./giveEdit.vue?vue&type=script&lang=js&"
export * from "./giveEdit.vue?vue&type=script&lang=js&"
import style0 from "./giveEdit.vue?vue&type=style&index=0&id=178ecbe1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178ecbe1",
  null
  
)

export default component.exports